import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { environment } from '../../../../environments/environment';
import { FacilityDetailsService } from '../../services/facility-details.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { CommonUtil } from '../../../core/Utils/common-util';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-equipment-availability-widget-modal',
  templateUrl: './equipment-availability-widget-modal.component.html',
  styleUrls: ['./equipment-availability-widget-modal.component.css']
})
export class EquipmentAvailabilityWidgetModalComponent implements OnInit {

  // subscriptions
  private _facilityOnChange: Subscription;

  currentFacility: FacilityObject;

  constructor(
    private rootScopeService: RootScopeService,
    private facilityDetailService: FacilityDetailsService,
    private _facilityService: FacilityService,
    public commonUtil: CommonUtil,
    private _router: Router
  ) { }
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;

  @Output() onClose: EventEmitter<any> = new EventEmitter();
  ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;
    this.getRootScopeData();

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
    });
  }

  ngOnDestroy() {
    // destroy subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
    });
  }

  updateEquipmentAvailWidgetModal(goToScreen: string) {
    if (goToScreen === 'setup') {
      this._router.navigate(['/facility/equipment']);
      this.onClose.emit({isNavigated: true});
    } else {      
      this.onClose.emit();
    }
    this.rootScopeData.popupData.showMicrositePopup  = false;
  }
}

